import { appSelectors } from '@appStore/reducers/app.ts';
import { PeopleOutlined, PersonSearchOutlined } from "@mui/icons-material";
import { Grid2 as Grid, SvgIconProps } from "@mui/material";
import { Dispatch, FC, ReactElement, SetStateAction } from "react";

import { useAppSelector } from "../../../../../shared/hooks";
import { EXPORT_CONTACTS } from "../../constants.ts";
import {
  CalendarIcon,
  CompassIcon,
  GroupIcon,
  LinkedInIcon,
  LinkIcon,
  UploadIcon,
} from "../../icons";
import { TExportContactsOption, TExportContactsType } from "../../types.ts";
import { ExportOption } from "../ExportOption";

const EXPORT_CONTACTS_OPTIONS =
  EXPORT_CONTACTS.OPTIONS as TExportContactsOption[];

const EXPORT_ICONS_MAP: Record<TExportContactsType, FC<SvgIconProps>> = {
  linkedinCustomizedProfileUrl: UploadIcon,
  linkedInEvent: CalendarIcon,
  linkedInGroup: GroupIcon,
  linkedInMyConnections: PeopleOutlined,
  linkedinProfileUrl: LinkIcon,
  linkedInSearch: LinkedInIcon,
  recruiterSearch: PersonSearchOutlined,
  salesNavigator: CompassIcon,
};

type TExportPickerProps = {
  exportType: null | TExportContactsType;
  setExportType: Dispatch<SetStateAction<null | TExportContactsType>>;
};

const ExportPicker: FC<TExportPickerProps> = ({
                                                exportType,
                                                setExportType,
                                              }: TExportPickerProps): ReactElement => {
  const isNotLogged = useAppSelector(appSelectors.notLoggedLI);
  const linkedInfo = useAppSelector(
    (state) => appSelectors.appProfile(state)?.linkedInProfile
  );
  const profile = useAppSelector(appSelectors.appProfile);

  const fullName = `${linkedInfo?.givenName} ${linkedInfo?.familyName}`;

  return (
    <Grid container spacing="16px">
      {EXPORT_CONTACTS_OPTIONS.map(
        ({
           description,
           isAuthRequired,
           isComingSoon,
           isPremium,
           title,
           value,
         }) => {
          const icon = EXPORT_ICONS_MAP[value];
          const isDisabledByAuth = isAuthRequired && isNotLogged;
          const isDisabledBySubscription =
            isPremium && !profile?.isProPlanAccessible;
          const isDisabled =
            isComingSoon || isDisabledBySubscription || isDisabledByAuth;
          const isSelected = !isDisabled && exportType === value;

          return (
            <Grid key={value} size={3}>
              <ExportOption
                description={description}
                icon={icon}
                info={
                  isDisabledByAuth
                    ? `Please, sign in at LinkedIn as ${fullName} to proceed.`
                    : undefined
                }
                isComingSoon={isComingSoon}
                isDisabled={isDisabled}
                isPremium={isDisabledBySubscription}
                isSelected={isSelected}
                onClick={() => setExportType(value)}
                title={title}
                value={value}
              />
            </Grid>
          );
        }
      )}
    </Grid>
  );
};

export default ExportPicker;
